import classNames from "classnames/bind";
import Image, { ImageProps } from "common/blocks/Image";
import UIIcon from "common/blocks/UIIcon";
import SmartLink from "common/wrapper/SmartLink";

import styles from "./FeaturedCard.module.scss";

const cx = classNames.bind(styles);

export type FeaturedCardProps = {
    image: ImageProps;
    title: string;
    className?: string;
    href?: string;
    isInline?: boolean;
    ctaLabel?: string;
    isSmall?: boolean;
};

const FeaturedCard = ({
    image,
    title,
    className,
    href,
    isInline,
    ctaLabel,
    isSmall,
}: FeaturedCardProps) => (
    <SmartLink href={href as string}>
        <a className={cx("container", { small: isSmall }, { inline: isInline }, className)}>
            <div className={cx("imageWrapper")}>
                {/* eslint-disable-next-line jsx-a11y/alt-text */}
                <Image {...image} layout="intrinsic" width={310} height={190} objectFit="cover" />
            </div>
            <div className={cx("contentWrapper")}>
                <h4 className={cx("title")}>{title}</h4>
                {isSmall ? (
                    <UIIcon icon="ChevronRight" className={cx("ctaArrow")} />
                ) : (
                    <span className={cx("ctaLabel")}>{ctaLabel}</span>
                )}
            </div>
        </a>
    </SmartLink>
);

export default FeaturedCard;
